import {BooleanRouteOption} from './boolean-route-option';
import {ActivatedRouteSnapshot} from '@angular/router';
import {FinancialHealthSeriesOption} from '../financial-health-series';

export class DisplayIndicatorNetRouteOption extends BooleanRouteOption {
	constructor(
		route: ActivatedRouteSnapshot,
		defaultValue = false,
	) {
		super(
			FinancialHealthSeriesOption.displayIndicatorNet,
			route,
			defaultValue
		);
	}
}
